import React from 'react';
import { Button, IconButton, TextInput, VerifiedDefaultIcon } from '@ntuctech/tangram-web';
import { useRouter } from 'next/router';
import styled from 'styled-components';

import {
  ERROR_EMAIL_TAKEN,
  PWL_CONNECTION_EMAIL,
  PWL_CONTACT_EMAIL,
} from '../../../services/api/constants';
import { fetcherApiRoute } from '../../../services/api/fetcher';
import { isEmail } from '../../../services/input-validator';
import { startPasswordless } from '../../../services/profile';

import {
  checkSameAsMyinfoAndVerified,
  handleCancel,
  updateMiCallbackUiAfterSave,
} from './helperFunction';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 100%;
`;

const VerifyButtonSc = styled(Button)`
  margin-left: 1rem;
`;

const EmailInputSc = styled.div`
  margin-top: 1.25rem;
`;

const commonTrackingParams = {
  screenName: 'account | myinfo onboarding verification',
  previousScreenName: 'account | authentication',
  screenSection: 'widget | myinfo edit email',
  previousScreenSection: null,
  buttonType: 'navigational style',
};

const EmailInput = ({
  setValue,
  value,
  handleCloseSideSheet,
  setToggleView,
  setEditableFlowError,
  userData,
  myinfoData,
  setMyinfoData,
  keyValue,
  setShowToast,
  isPersonaEnabled,
  flowType,
  trackSegment,
  getSegmentUtmParams,
  isMyinfoFapiEnabled,
}) => {
  const { email, email_last_verified } = userData || {};
  const [inputError, setInputError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [hasEdited, setHasEdited] = React.useState(false);
  const router = useRouter();
  const { query } = router;
  const getUtmParam = getSegmentUtmParams && getSegmentUtmParams(query);

  const handleOnChange = (e) => {
    setHasEdited(true);
    if (isEmail(e.target.value)) {
      setInputError('');
    } else {
      setInputError('Please enter a valid email');
    }
    setValue(e.target.value);
  };
  const handleVerify = async () => {
    const editedDiffEmail = hasEdited && value !== email;
    const editedLpEmailUnverified = hasEdited && value === email && !email_last_verified;

    setLoading(true);
    if (flowType === 'myinfo') {
      const trackingParams = {
        ...commonTrackingParams,
        buttonName: 'myinfo verify',
      };
      trackSegment && trackSegment('Button Clicked', trackingParams, getUtmParam);
      try {
        const response = await fetcherApiRoute('/api/v2/myinfo-signup-email-verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: value,
          }),
        });

        if (!response?.available) {
          setLoading(false);
          setInputError(ERROR_EMAIL_TAKEN);
        } else {
          startPasswordless(
            PWL_CONNECTION_EMAIL,
            value,
            () => setToggleView('otp'),
            () => setEditableFlowError(true),
            () => setLoading(false),
          );
        }
      } catch (err) {
        // TODO: handle error
      }
    } else if (editedDiffEmail || editedLpEmailUnverified) {
      startPasswordless(
        PWL_CONTACT_EMAIL,
        value,
        () => setToggleView('otp'),
        () => setEditableFlowError(true),
        () => setLoading(false),
      );
    } else {
      fetcherApiRoute(
        /* eslint-disable */
        isMyinfoFapiEnabled
          ? '/api/v2/myinfo-personaldetails-fapi'
          : isPersonaEnabled
          ? '/api/v2/myinfo-update-personaldetails'
          : '/api/myinfo-update-personaldetails',
        {
          method: 'POST',
          body: JSON.stringify({
            value,
            field: 'email',
            sessionId: myinfoData.session_id,
          }),
        },
      )
        .then(() => {
          updateMiCallbackUiAfterSave({
            myinfoData,
            setMyinfoData,
            newValue: value,
            key: keyValue,
            handleCloseSideSheet,
            setShowToast,
          });
        })
        .catch(() => {
          setEditableFlowError(true);
        })
        .finally(() => {
          setHasEdited(false);
          setLoading(false);
        });
    }
  };

  return (
    <EmailInputSc>
      <TextInput
        label={'Email'}
        description={'A 6-digit OTP will be sent to this email.'}
        value={value}
        onChange={handleOnChange}
        error={inputError}
        required
        suffix={
          checkSameAsMyinfoAndVerified(value, email, keyValue) && (
            <IconButton size="m">
              <VerifiedDefaultIcon />
            </IconButton>
          )
        }
      />
      <ButtonWrapper>
        <Button
          variant="secondary"
          onClick={() => {
            handleCancel({
              flowType,
              commonTrackingParams,
              trackSegment,
              getUtmParam,
              handleCloseSideSheet,
            });
          }}
        >
          Cancel
        </Button>
        <VerifyButtonSc
          variant="primary"
          onClick={handleVerify}
          disabled={inputError.length > 0}
          loading={loading}
        >
          {checkSameAsMyinfoAndVerified(value, email, keyValue) ? 'Save' : 'Verify'}
        </VerifyButtonSc>
      </ButtonWrapper>
    </EmailInputSc>
  );
};

export default EmailInput;
